module.exports = __webpack_public_path__ + "public/images/graduate.f7e9bc9e7f8786f9142bacd9b719c519.webp";